import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { Toast } from "vant";
import { encryptionEditName } from "@/api/php/user";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'selfinfo',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "5a010832-btnTextColor": (btnTextColor.value),
  "5a010832-btnColor": (btnColor.value)
}))

const { t } = useI18n()
const piniaStore = usePiniaState();
const { user, isYk } = storeToRefs(piniaStore);
const { toLogin, Revisename } = piniaStore;
const router = useRouter();
const name = ref("");

onMounted(() => {
  toLogin();
  name.value = user.value.nickName;
  console.log(user.value);
});

const ok = async () => {
  if (name.value == user.value.nickName) {
    Toast({
      message: t('me.ncxt'),
      position: "bottom",
    });
  } else if (name.value == "") {
    Toast({
      message: t('me.ncbnwk'),
      position: "bottom",
    });
  } else if (name.value.length > 6) {
    Toast({
      message: t('me.texttoolong'),
      position: "bottom",
    });
  } else {

    // if (/^[\u4e00-\u9fa5]+$/.test(name.value)) {
      const res: any = await encryptionEditName({ username: name.value });
      if (res.code == 200) {
        Revisename(name.value);
        Toast.success(t('me.nickMdySucc'));
        router.back();
      }
      console.log(res);
    // } else {
    //   Toast({
    //     message: t('me.onlyUseChina'),
    //     position: "bottom",
    //   });
    // } 
  }
};
const checkValue = () => {
  if (name.value != "") {
    btnColor.value = "#0D0D0D"
    btnTextColor.value = "#fff"
  } else {
    btnColor.value = "#ECECEC"
    btnTextColor.value = "#898989"
  }
}
const btnColor = ref("#ECECEC")
const btnTextColor = ref("#898989")


const __returned__ = { t, piniaStore, user, isYk, toLogin, Revisename, router, name, ok, checkValue, btnColor, btnTextColor }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})